export const buildPaidcoursesMetaData = ({
  route,
  component,
  method,
  action,
  triggerSource,
  surface = null,
  courseId = null,
  extra = {}
} = {}) => {
  const routePath = route?.fullPath ?? `${window.location.pathname}${window.location.search}${window.location.hash}`

  return {
  action: action || null,
  component: component || null,
  method: method || null,
  trigger_source: triggerSource || null,
  surface,
  course_id: courseId ?? route?.params?.courseId ?? null,
  page_url: window.location.href,
  route_path: routePath,
  ...extra
  }
}
